import { render, staticRenderFns } from "./music_list.vue?vue&type=template&id=323d196c&scoped=true"
import script from "./music_list.vue?vue&type=script&lang=js"
export * from "./music_list.vue?vue&type=script&lang=js"
import style0 from "./music_list.vue?vue&type=style&index=0&id=323d196c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d196c",
  null
  
)

export default component.exports